// extracted by mini-css-extract-plugin
export default {"transfer":"style_transfer__wMfmp","info":"style_info__jq3tb","instrument":"style_instrument__wTwTU","toggleBtn":"style_toggleBtn__V9Gzw","available":"style_available__y3o-P"};